import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import jobRolesCollection from 'modules/job_catalog/store/collections/roles'
import type JobRole from 'modules/job_catalog/store/models/JobRole'

const useAssignableJobRoles = (
  legalEntitiesIds: string[],
  currentRole: JobRole | undefined | null = null
) => {
  const isAssignable = useUnsafeCallback(
    (role: JobRole | undefined) => {
      if (!role) {
        return true
      }

      const isInAllLegalEntities = legalEntitiesIds.every((x) => role.isRoleInLegalEntityId(x))
      return isInAllLegalEntities && role.isActive
    },
    [legalEntitiesIds]
  )

  const assignableJobRoles = useUnsafeMemo(() => {
    const legalEntityRoles =
      jobRolesCollection.filter(
        (x) =>
          x.isActive && legalEntitiesIds.every((y) => x.attributes.legal_entities_ids.includes(y))
      ) || []
    const options =
      !currentRole || isAssignable(currentRole)
        ? legalEntityRoles
        : [currentRole, ...legalEntityRoles]
    const sortedOptions = options.sort((a, b) => (a.attributes.name > b.attributes.name ? 1 : -1))
    return sortedOptions
  }, [legalEntitiesIds, currentRole, isAssignable])

  return { assignableJobRoles, isJobRoleAssignable: isAssignable }
}

export default useAssignableJobRoles
